export default {
  statusIntroDisplayed: false
}
